<template>
  <div ref="dom" class="charts smooth-line"></div>
</template>

<script>
import * as echarts from 'echarts'
import { on, off } from '@/libs/tools'

export default {
  name: 'SmoothLine',
  props: {
    value: Object,
    text: String,
    subtext: String
  },
  data () {
    return {
      dom: null
    }
  },
  methods: {
    resize () {
      this.dom.resize()
    },
    initXY () {
      this.updateSeriesData(this.value)
    },
    updateData (data) {
      this.value = data
      this.updateSeriesData(data)
    },
    updateSeriesData (data) {
      let seriesData = []
      for (let i = 0; i < data.y.length; i++) {
        seriesData.push({
          data: data.y[i].data,
          name: data.y[i].name,
          type: 'line',
          smooth: true
        })
      }
      this.initData(data.x, seriesData)
    },
    initData (xAxisData, seriesData) {
      let option = {
        title: {
          text: this.text,
          x: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: 'circle',
          top: '5%',
          right: '5%',
          itemWidth: 6,
          itemGap: 20,
          textStyle: {
            color: '#556677'
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: seriesData
      }
      this.dom = echarts.init(this.$refs.dom, 'tdTheme')
      this.dom.setOption(option)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initXY()
      on(window, 'resize', this.resize)
    })
  },
  beforeDestroy () {
    off(window, 'resize', this.resize)
  }
}
</script>
